import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';
import { Container } from '@change-corgi/design-system-legacy/layout';
import { derivedStyle } from '@change-corgi/design-system-legacy/theme';

import { usePageBanner } from './hooks/usePageBanner';

// Currently this banner is failing separation of concerns because it depends on the
// set_password page to set the query param
export function PageBanner() {
	const {
		data: { message },
		actions: { closeBanner },
	} = usePageBanner();

	if (!message) return null;

	return (
		<Container
			sx={{
				maxWidth: '620px',
				paddingInline: 'sunrise.4',
				marginTop: 'sunrise.4',
				'& > div': {
					backgroundColor: 'sunrise.semantic.fill.success.weaker',
					border: derivedStyle((theme) => `1px solid ${theme.colors.sunrise?.semantic.stroke.success.weak}`),
					borderRadius: 'big',
					color: 'sunrise.semantic.typography.success',
					padding: 0,
					'& > div': {
						padding: 'sunrise.5',
						'& > span:first-of-type': {
							fontSize: '24px',
						},
					},
					'& button': {
						height: '24px',
						'& span': {
							fontSize: '24px',
						},
					},
					'& svg': {
						color: 'sunrise.semantic.icon.success',
					},
				},
			}}
		>
			<PageMessage
				role="alert"
				message={message}
				severity="success"
				data-testid="start-a-petition-success-banner"
				data-qa="start-a-petition-success-banner"
				dismissable
				onClose={closeBanner}
			/>
		</Container>
	);
}
